<template>
    <div class="container" :style="{ background: `url(${bg})` }">
        <div class="container-3d" ref="container"></div>
        <loading-view :show="showLoading && loading" :progress="loadingProgress" class="loading"></loading-view>
        <div class="header">
            <div v-if="title && showEye" class="title-wrapper" style="font-size: 16px;">
                <span class="title" :style="{
                    color: this.style === 'dark' ? '#ffffff' : '#333333'
                }">{{ title }}</span>
                <img class="down" style="width: 15px;height: 12px;" :src="this.style === 'dark' ? down1 : down"></img>
            </div>
            <div v-if="showEye" :class="isLandscape ? 'otherSize' : 'size'">
                <div class="btn" @click="toNewUrl">
                    <img class="icon1" :src="leftIcon"></img>
                    <span>实景展示</span>
                </div>
                <div class="btn" @click="clickEye">
                    <img class="icon2" :src="rightIcon"></img>
                    <span>产品尺寸</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoadingView from './LoadingView.vue'
import N3dViewer from './n3dViewer';
import eysOpen from '../../../assets/images/model/eye-open.png'
import eysClose from '../../../assets/images/model/eye-close.png'
import eysOpen1 from '../../../assets/images/model/eye-open1.png'
import eysClose1 from '../../../assets/images/model/eye-close1.png'
import down from '../../../assets/images/model/down.png'
import down1 from '../../../assets/images/model/down1.png'
import { Toast } from 'mint-ui';
export default {
    components: {
        LoadingView
    },
    props: {
        // url: {
        //     type: String,
        //     default: ''
        //     // required: true
        //     // default: 'https://pro-core.ali-cache.com/2024/01/ao_selection/dev/705dba01/model/cf2.gltf'
        // },
        showLoading: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        eyeImage: {
            get() {
                return this.eyeStatus ? (this.style === 'dark' ? eysOpen : eysOpen1) : (this.style === 'dark' ? eysClose : eysClose1)
            }
        }
    },
    data() {
        return {
            loading: false,
            loadingProgress: 0,
            container: null,
            viewer: null,
            initing: false,
            title: '',
            showSize: 1,
            showEye: false,
            eyeStatus: true,
            style: 'dark',
            eysOpen,
            eysOpen1,
            eysClose,
            eysClose1,
            down,
            down1,
            bg: '',
            link: '',
            leftIcon: 'https://pro-mixed-tt.ali-cache.com/2023/nxhbase/02/70/uploads/cmsarticle/attach/2024/06/25/1719307906RiDB.png',
            rightIcon: 'https://pro-mixed-tt.ali-cache.com/2023/nxhbase/02/70/uploads/cmsarticle/attach/2024/06/25/1719307954Lk0l.png',
            isLandscape: false,
            innerWidth: 0,
            scale: 0.5
        }
    },
    watch: {
        container: function (newContainer) {
            this.tryInit(newContainer, this.url)
        },
        url: function (newUrl) {
            this.tryInit(this.container, newUrl)
        },
        innerWidth: function (newValue) {
            // console.log('innerWidth', newValue);
        }
    },
    mounted() {
        // 添加resize事件监听
        window.addEventListener('resize', this.getWh);
        this.getWh()
        this.container = this.$refs.container
        let query = this.$route.query
        console.log('query', query);
        if (query.url) {
            this.url = decodeURIComponent(query.url)
            // https://xxxx.xxxx.com/abc/def.gltf 截取路径目录
            try {
                // let folder = this.url.substring(0, this.url.lastIndexOf('/') + 1)
                // console.log('folder', folder);
                let url = 'https://pro-mixed-tt.ali-cache.com/aotest/uploads/goods/model/1400/'
                let folder = query.style === 'dark' ? url + '17205764250348/' : url + '17138442804723/'
                // https://pro-mixed-tt.ali-cache.com/aotest/uploads/goods/model/1400/17138442804723/bg.jpg // 浅色
                // https://pro-mixed-tt.ali-cache.com/aotest/uploads/goods/model/1400/17205764250348/bg.jpg // 深色
                this.bg = folder + 'bg.jpg'
                // console.log(this.bg, 'bg');
            } catch (e) {
                console.error('背景图片error')
            }
        }
        if (query.showLoading) {
            this.showLoading = query.showLoading === '1'
        }
        if (query.title) {
            this.title = decodeURIComponent(query.title)
        }
        if (query.scale) {
            this.scale = query.scale
        }
        // if (query.eye) {
        //     this.showEye = query.eye === '1'
        // }
        if (query.style) {
            this.style = query.style
            console.log('style', this.style);
        }
        this.tryInit(this.container, this.url)
        if (query.link) {
            this.link = query.link
        }
    },
    beforeDestroy() {
        // 移除resize事件监听
        window.removeEventListener('resize', this.getWh);
    },
    methods: {
        loadingCb(progress) {
            // console.log('progress', progress.data)
            if (progress.data == 100) {
                this.showEye = true
            }
            this.loadingProgress = Math.floor(progress.data)
        },
        loadedCb() {
            this.loading = false
            this.initing = false
        },
        getViewer() {
            if (!this.viewer) {
                this.viewer = new N3dViewer(this.container, {
                    scale: this.scale
                })
                this.viewer.addEventListener('loading', this.loadingCb)
                this.viewer.addEventListener('loaded', this.loadedCb)
            }
            return this.viewer;
        },
        tryInit(container, url) {
            if (this.initing) {
                return
            }
            this.initing = true
            if (container && url) {
                let viewer = this.getViewer()
                viewer.init(url)
                this.loading = true
            } else {
                if (this.viewer) {
                    this.viewer.dispose()
                }
            }
        },
        clickEye() {
            if (this.viewer) {
                if (this.eyeStatus) {
                    this.eyeStatus = false
                    this.viewer.changeVis('size', false)
                } else {
                    this.eyeStatus = true
                    this.viewer.changeVis('size', true)
                }
            }

        },
        toNewUrl() {
            console.log('跳转', this.link);
            if (this.link && this.link !== 'null') {
                // this.$router.push({
                //     path: `/cs/preview/preview`,
                //     query: { link: this.link }
                // })
                let link = JSON.parse(this.link)
                window.location.href = link[0].link; // 'https://bbcm3f1el5s.720yun.com/vr/b1djzgwfem9'
            } else {
                Toast({
                    message: "暂无场景，敬请期待~",
                    position: 'center',
                    duration: 1200
                });
            }
            
        },
        getWh() {
            this.innerWidth = window.innerWidth
            // console.log('设备宽高', window.innerWidth, window.innerHeight);
            this.isLandscape = window.innerWidth > window.innerHeight
        },
    }
}
</script>
<style scoped lang="scss">
.container {
    position: relative;
    width: 100vw;
    height: 100vh;
    background-size: cover !important;

    .container-3d {
        position: absolute;
        width: 100%;
        height: 100%;

        canvas {
            inset: 0;
        }
    }

    .loading {
        position: absolute;
        background: #ffffff;
        inset: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .header {
        z-index: 999;
        position: absolute;
        top: 30px;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .title-wrapper {
            font-weight: 700;
            // font-size: 28px !important;
            color: #333333;
            line-height: 28px;
            text-align: center;
            font-style: normal;
            display: flex;
            justify-content: center;
            align-items: center;
            .down {
                width: 18px;
                height: 14px;
                margin-left: 8px;
            }
        }

        .size {
            margin: 0 auto;
            display: flex;
            position: fixed;
            top: 80vh;
            .btn {
                display: flex;
                align-items: center;
                padding: 15px 30px;
                background-color: #c9cdd0;
                border-radius: 10px;
                margin: 0 10px;
                .icon1 {
                    width: 30px;
                    height: 24px;
                    margin-right: 10px;
                }
                .icon2 {
                    width: 22px;
                    height: 28px;
                    margin-right: 10px;
                }
            }
        }
        .otherSize {
            margin: 0 auto;
            display: flex;
            position: fixed;
            bottom: 10%;
            .btn {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                background-color: #c9cdd0;
                border-radius: 10px;
                margin: 0 25px;
                .icon1 {
                    width: 15px;
                    height: 12px;
                    margin-right: 5px;
                }
                .icon2 {
                    width: 11px;
                    height: 14px;
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>import { lastIndexOf } from 'lodash';

